import React from 'react';

export const JiraAppSelectorIconWithGithub = (): React.JSX.Element => (
	<svg
		role="presentation"
		aria-hidden="true"
		width="42"
		height="16"
		viewBox="0 0 42 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		{/* Google Drive icon */}
		<mask id="path-1-inside-1_7_93401" fill="white">
			<path d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z" />
		</mask>
		<path
			d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z"
			fill="white"
		/>
		<path
			d="M30 0V1H38V0V-1H30V0ZM42 4H41V12H42H43V4H42ZM38 16V15H30V16V17H38V16ZM26 12H27V4H26H25V12H26ZM30 16V15C28.3431 15 27 13.6569 27 12H26H25C25 14.7614 27.2386 17 30 17V16ZM42 12H41C41 13.6569 39.6569 15 38 15V16V17C40.7614 17 43 14.7614 43 12H42ZM38 0V1C39.6569 1 41 2.34315 41 4H42H43C43 1.23858 40.7614 -1 38 -1V0ZM30 0V-1C27.2386 -1 25 1.23858 25 4H26H27C27 2.34315 28.3431 1 30 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-1-inside-1_7_93401)"
		/>
		<g clipPath="url(#clip0_7_93401)">
			<path
				d="M29.4727 11.3856L29.9431 12.194C30.0408 12.3641 30.1813 12.4978 30.3463 12.5951L32.0263 9.70203H28.6663C28.6663 9.89044 28.7151 10.0789 28.8129 10.249L29.4727 11.3856Z"
				fill="#0066DA"
			/>
			<path
				d="M33.9996 6.29834L32.3196 3.40527C32.1546 3.50252 32.0141 3.63623 31.9164 3.80641L28.8129 9.15494C28.7169 9.32145 28.6664 9.51002 28.6663 9.70195H32.0263L33.9996 6.29834Z"
				fill="#00AC47"
			/>
			<path
				d="M37.6533 12.5951C37.8182 12.4978 37.9588 12.3641 38.0565 12.194L38.252 11.8597L39.1867 10.249C39.2845 10.0789 39.3333 9.89044 39.3333 9.70203H35.973L36.688 11.0999L37.6533 12.5951Z"
				fill="#EA4335"
			/>
			<path
				d="M34 6.29846L35.68 3.40539C35.5151 3.30814 35.3257 3.25952 35.1302 3.25952H32.8698C32.6743 3.25952 32.4849 3.31422 32.3199 3.40539L34 6.29846Z"
				fill="#00832D"
			/>
			<path
				d="M35.9726 9.70203H32.0261L30.3461 12.5951C30.511 12.6923 30.7004 12.741 30.8959 12.741H37.1028C37.2983 12.741 37.4877 12.6863 37.6527 12.5951L35.9726 9.70203Z"
				fill="#2684FC"
			/>
			<path
				d="M37.6351 6.48068L36.0834 3.80641C35.9856 3.63623 35.8451 3.50252 35.6802 3.40527L34.0001 6.29834L35.9734 9.70195H39.3273C39.3273 9.51353 39.2785 9.32512 39.1807 9.15494L37.6351 6.48068Z"
				fill="#FFBA00"
			/>
		</g>
		{/* GitHub icon tile */}
		<path
			d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z"
			fill="#292A2E"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.9997 3C18.2386 3 15.9996 5.2952 15.9996 8.12659C15.9996 10.3916 17.4323 12.3133 19.419 12.9912C19.6689 13.0386 19.7606 12.88 19.7606 12.7446C19.7606 12.6223 19.756 12.2185 19.7538 11.7901C18.3628 12.1002 18.0693 11.1852 18.0693 11.1852C17.8418 10.5927 17.5141 10.4351 17.5141 10.4351C17.0604 10.1169 17.5483 10.1235 17.5483 10.1235C18.0504 10.1596 18.3148 10.6518 18.3148 10.6518C18.7607 11.4355 19.4845 11.2089 19.7698 11.0779C19.8147 10.7466 19.9442 10.5204 20.0872 10.3924C18.9767 10.2628 17.8092 9.8232 17.8092 7.85883C17.8092 7.29912 18.0045 6.8418 18.3244 6.48278C18.2725 6.35366 18.1013 5.83224 18.3728 5.12609C18.3728 5.12609 18.7927 4.98831 19.7482 5.65158C20.147 5.53799 20.5748 5.48103 20.9997 5.47908C21.4246 5.48103 21.8527 5.53799 22.2523 5.65158C23.2066 4.98831 23.6259 5.12609 23.6259 5.12609C23.898 5.83224 23.7268 6.35366 23.6749 6.48278C23.9955 6.8418 24.1895 7.29912 24.1895 7.85883C24.1895 9.82786 23.0198 10.2614 21.9064 10.3883C22.0857 10.5474 22.2455 10.8594 22.2455 11.3377C22.2455 12.0237 22.2397 12.5757 22.2397 12.7446C22.2397 12.881 22.3298 13.0409 22.5832 12.9905C24.5688 12.3119 25.9996 10.3909 25.9996 8.12659C25.9996 5.2952 23.761 3 20.9997 3Z"
			fill="white"
		/>
		{/* Jira icon */}
		<g clipPath="url(#clip1_7_93401)">
			<mask
				id="path-11-outside-2_7_93401"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="17"
				height="16"
				fill="black"
			>
				<rect fill="white" width="17" height="16" />
				<path d="M0 0H16V16H0V0Z" />
			</mask>
			<path
				d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
				fill="#1868DB"
			/>
			<g clipPath="url(#clip2_7_93401)">
				<path
					d="M5.98251 10.349H5.08098C3.72128 10.349 2.74585 9.51616 2.74585 8.29666H7.59345C7.8447 8.29666 8.00727 8.47512 8.00727 8.72795V13.606C6.79537 13.606 5.98251 12.6244 5.98251 11.2562V10.349ZM8.37675 7.92486H7.47522C6.11552 7.92486 5.14009 7.1069 5.14009 5.88739H9.9877C10.2389 5.88739 10.4163 6.05099 10.4163 6.30381V11.1818C9.20439 11.1818 8.37675 10.2003 8.37675 8.83205V7.92486ZM10.7858 5.51559H9.88424C8.52455 5.51559 7.54911 4.68276 7.54911 3.46326H12.3967C12.648 3.46326 12.8105 3.64172 12.8105 3.87967V8.75769C11.5986 8.75769 10.7858 7.77614 10.7858 6.40791V5.51559Z"
					fill="white"
				/>
			</g>
		</g>
		<path
			d="M16 0H15V16H16H17V0H16Z"
			fill="white"
			mask="url(#path-11-outside-2_7_93401)"
		/>
		<defs>
			<clipPath id="clip0_7_93401">
				<rect
					width="10.6667"
					height="9.48148"
					fill="white"
					transform="translate(28.6661 3.2594)"
				/>
			</clipPath>
			<clipPath id="clip1_7_93401">
				<path d="M0 0H16V16H0V0Z" fill="white" />
			</clipPath>
			<clipPath id="clip2_7_93401">
				<rect
					width="10.0647"
					height="10.1427"
					fill="white"
					transform="translate(2.74585 3.46338)"
				/>
			</clipPath>
		</defs>
	</svg>
);
